import { API_AUTH, setTokenGlobal } from "../common";
import { withCookies, Cookies } from "react-cookie";
import { getDomain } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
  token = token.substring(6);
  setTokenGlobal(token, urlNew);
}
export default {
  getAllRoleInUser: (params) => API_AUTH.get("users/getAllRoleInUser", params),
  GetAllUser: (tukhoa) => API_AUTH.get(`users/GetAllUser${tukhoa.params}`, {}),
  getUserByGroupCategoryID: (tukhoa) =>
    API_AUTH.get(`users/getUserByGroupCategoryID${tukhoa.params}`, {}),
  setUserByGroupCategoryID: (tukhoa) =>
    API_AUTH.post(`users/setUserByGroupCategoryID${tukhoa.params}`, {}),
  GetRoleHeader: (username, search, iBranch) =>
    API_AUTH.get(
      `users/GetRoleHeader?username=${username}&search=${search}&iBranch=${iBranch}`,
      {}
    ),
  getUserByStoreID: (tukhoa) =>
    API_AUTH.get(`kho/thongtinphanquyenkho${tukhoa.params}`, {}),
  setUserByStoreID: (tukhoa) =>
    API_AUTH.post(`kho/setUserByStoreID${tukhoa.params}`, {}),
  getRoleByCode: (code) => API_AUTH.get(`users/getRoleByCode?code=${code}`, {}),
};
